import placeholderApi from '@/api/placeholder.api'

const state = {
  placeholdersScheduleGlobal: [],
  placeholdersContractGlobal: [],
  placeholdersContractContact: [],
  placeholdersContractVenue: []
}


const getters = {
  placeholdersScheduleGlobal: (state) => {
    return state.placeholdersScheduleGlobal
  },

  placeholdersContractGlobal: (state) => {
    return state.placeholdersContractGlobal
  },

  placeholdersContractContact: (state) => {
    return state.placeholdersContractContact
  },

  placeholdersContractVenue: (state) => {
    return state.placeholdersContractVenue
  }
}


const actions = {
  async loadPlaceholdersScheduleGlobal ({ commit, rootState }) {
    const response = await placeholderApi.getPlaceholdersScheduleGlobal(rootState.tenant.current)
    commit('SET_PLACEHOLDERS_SCHEDULE_GLOBAL', response.data)
  },

  async loadPlaceholdersContractGlobal ({ commit, rootState }) {
    const response = await placeholderApi.getPlaceholdersContractGlobal(rootState.tenant.current)
    commit('SET_PLACEHOLDERS_CONTRACT_GLOBAL', response.data)
  },

  async loadPlaceholdersContractContact ({ commit, rootState }) {
    const response = await placeholderApi.getPlaceholdersContractContact(rootState.tenant.current)
    commit('SET_PLACEHOLDERS_CONTRACT_CONTACT', response.data)
  },

  async loadPlaceholdersContractVenue ({ commit, rootState }) {
    const response = await placeholderApi.getPlaceholdersContractVenue(rootState.tenant.current)
    commit('SET_PLACEHOLDERS_CONTRACT_VENUE', response.data)
  }
}


const mutations = {
  SET_PLACEHOLDERS_SCHEDULE_GLOBAL (state, placeholdersScheduleGlobal) {
    state.placeholdersScheduleGlobal = [...placeholdersScheduleGlobal]
  },

  SET_PLACEHOLDERS_CONTRACT_GLOBAL (state, placeholdersContractGlobal) {
    state.placeholdersContractGlobal = [...placeholdersContractGlobal]
  },

  SET_PLACEHOLDERS_CONTRACT_CONTACT (state, placeholdersContractContact) {
    state.placeholdersContractContact = [...placeholdersContractContact]
  },

  SET_PLACEHOLDERS_CONTRACT_VENUE (state, placeholdersContractVenue) {
    state.placeholdersContractVenue = [...placeholdersContractVenue]
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
